import React from 'react';
export const EditIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.0858 2.08579L11.9142 1.91422C11.1331 1.13317 9.86682 1.13317 9.08577 1.91422L1.75 9.25L1.75 12.25H4.75L12.0858 4.91421C12.8668 4.13316 12.8668 2.86684 12.0858 2.08579Z"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
